// style-utils.js

import '../../scss/_normalizer.scss';
import '../../scss/_fontsAkn.scss';
import { isIOS } from 'react-device-detect';

/**
 * These imports don't work. Keeping file as a reference
 * untl we figure out what to do. It may need to be
 * directly included here.
 */
// import '../../scss/_variables.scss';

let breakpoint = '650px';
if (isIOS) {
  breakpoint = '1000px';
}

/**
 * Wrapper CSS element.
 *
 * @returns { CSS } element
 */
export function wrapper() {
  return `
    font-family: 'ArtifaktElement';
  `;
}

/**
 * Form CSS element.
 *
 * @returns { CSS } element
 */
export function form() {
  return (
    `
    margin: 32px 32px 0px;
    @media only screen and (max-width: ` +
    breakpoint +
    `) {
      margin: 24px 24px 0px;
    }
  `
  );
}

/**
 * Form CSS element.
 *
 * @returns { CSS } element
 */
export function formSubmission() {
  return (
    `
    margin: 20px 32px 0px;
    @media only screen and (max-width: ` +
    breakpoint +
    `) {
      margin: 20px 24px 0px;
    }
  `
  );
}

/**
 * Heading CSS element.
 *
 * @param { string } heading - of CSS element
 *
 * @returns { CSS } element
 */
export function heading(heading) {
  let style = '';
  switch (heading) {
    case 'H1': {
      style = `
        font-size: 24px;
        line-height: 30px;
        font-weight: 300;
        font-style: normal;
        color: #444444;
        margin-bottom: 12px;
      `;
      break;
    }
    case 'H2': {
      style = `
        font-family: "ArtifaktElementLight";
        font-size: 30px;
        line-height: 35px;
        color: #222;
      `;
      break;
    }
    case 'H3': {
      style = `
        font-family: "ArtifaktElementMedium";
        font-size: 21px;
        line-height: 25px;
        color: #444;
      `;
      break;
    }
    case 'H4': {
      style = `
        font-family: "ArtifaktElementLight";
        font-size: 19px;
        line-height: 24px;
        color: #222;
      `;
      break;
    }
    case 'H5': {
      style = `
        font-family: "ArtifaktElementMedium";
        font-size: 16px;
        line-height: 21px;
        color: #222;
      `;
      break;
    }
    case 'H6': {
      style = `
        font-family: "ArtifaktElementMedium";
        font-size: 14px;
        line-height: 19px;
        color: #222;
      `;
      break;
    }
    default: {
      break;
    }
  }

  return style;
}

/**
 * PrimaryCtaButton CSS element.
 *
 * @returns { CSS } element
 */
export function primaryCtaButton() {
  return (
    `
    font-family: "ArtifaktElement";
    font-size: 16px;
    font-weight: normal;
    line-height: 30px;
    color: #ffffff;
    margin-bottom: 32px;
    // position: relative;
    @media only screen and (max-width: ` +
    breakpoint +
    `) {
      margin-bottom: initial;
      margin-bottom: 16px;
    }
    .hig__button-v1--type-primary {
      border: 0px;
      font-size: 16px;
      font-weight: normal;
      background-color: #0696d7;
      border-radius: 0px;
      text-align: left;
      line-height: 18px;
      min-width: 220px;
      // width: 262px;
      max-width: 282px;
      height: 34px;
      padding: 0 16px;
      white-space: normal;
      @media only screen and (max-width: ` +
    breakpoint +
    `) {
        min-width: 282px;
        margin-left: 1px;
        max-width: 282px;
      }
      &:hover,
      &:focus,
      &:active {
        background-color: #0696d7;
      }
    }
    .hig__button-v1.hig__button-v1--disabled {
      background-color: #dadada;
    }
    .hig__button__title {
      :after {
        float: right;
        content: url(caret-right.svg);
        padding-left: 10px;
      }
    }
  `
  );
}

/**
 * SecondaryCtaButton CSS element.
 *
 * @returns { CSS } element
 */
export function secondaryCtaButton() {
  return (
    `
    font-family: "ArtifaktElement";
    font-size: 16px;
    font-weight: normal;
    line-height: 30px;
    color: #999999;
    border-color: #dadada;
    margin-bottom: 32px;
    @media only screen and (max-width: ` +
    breakpoint +
    `) {
      margin-bottom: initial;
      margin-bottom: 16px;
    }
    width: 100%;
    .hig__button-v1 {
      border-color: #dadada;
      border-width: 2px;
      background: none;
      color: #999999;
      text-align: left;
      border-radius: 0px;
      font-size: 16px;
      font-weight: normal;
      line-height: 30px;
      min-width: 90px;
      height: 34px;
      padding: 0 16px;
      @media only screen and (max-width: ` +
    breakpoint +
    `) {
        min-width: 282px;
        max-width: 282px;
      }
    }
    .hig__button-v1:hover, 
    .hig__button-v1:active, 
    .hig__button-v1:focus {
      border-color: #dadada;
      color: #999999;
      background: none;
    }
  `
  );
}

/**
 * FieldLabel CSS element.
 *
 * @returns { CSS } element
 */
export function fieldLabel() {
  return `
    font-family: "ArtifaktElementMedium";
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    line-height: 30px;
    color: #222222;
  `;
}

/**
 * FieldInput CSS element.
 *
 * @returns { CSS } element
 */
export function fieldInput() {
  return (
    `
    font-family: "ArtifaktElement";
    font-size: 14px;
    font-weight: normal;
    color: #666666;
    min-width: 292px;
    height: 34px;
    margin-bottom: 24px;
    border: 1px solid #DAE1E6;
    &:hover {
      border: 1px solid #0696d7;
    }
    @media only screen and (max-width: ` +
    breakpoint +
    `) {
      min-width: 225px;
      max-width: 100%;
      margin-left: 1px;
      margin-right: 1px;
      margin-bottom: 24px;
    }
    &.invalid-email {
      border: 1px solid #dd2222;
      &:hover {
        border: 1px solid #dd2222;
      }
      span {
        margin-left: 2px;
      }
    }
    .TextFieldCore {
      height: 100%;
      width: 100%;
      border: none;
      outline: none;
      border-radius: 0px;
      padding: 0px;
      &:hover,
      &:focus,
      &:active {
        border: none;
        outline: none;
        border-radius: 0px;
        margin: 0px;
        padding: 0px;
      }
    }
    .TextFieldCore input[type='text'] {
      border: none;
      outline: none;
      height: 100%;
      width: 100%;
      font-family: inherit;
      font-size: inherit;
      font-weight: inherit;
      color: inherit;
      margin: 0px;
      padding: 0px;
      text-indent: 10px;
    }
    // .TextFieldCore--invalid {
    //   border: 1px solid #dd2222;
    //   margin-bottom: 0px;
    //   &:hover {
    //     border: 1px solid #dd2222;
    //   }
    // }
    // .InputValidationView__validation-message {
    //   font-family: "ArtifaktElement";
    //   font-size: 12px;
    //   font-weight: normal;
    //   color: #dd2222;
    //   margin-top: 2px;
    // }
  `
  );
}

/**
 * BoldText CSS element.
 *
 * @returns { CSS } element
 */
export function boldText() {
  return `
    font-family: inherit;
    font-size: inherit;
    color: inherit;
    font-weight: 700;
  `;
}

/**
 * CaptionText CSS element.
 *
 * @returns { CSS } element
 */
export function captionText() {
  return `
    font-family: "ArtifaktElementLight";
    font-size: 14px;
    font-weight: normal;
    line-height: 30px;
    color: #888888;
  `;
}

/**
 * InputMessage CSS element.
 *
 * @returns { CSS } element
 */
export function inputMessage() {
  return (
    `
    font-family: "ArtifaktElementLight";
    font-size: 14px;
    font-weight: normal;
    line-height: 18px;
    color: #999999;
    .hig__text-area {
      margin-top: 0px;
      margin-bottom: 0px;
      width: 606px;
      border: 1px solid #DAE1E6;
      @media only screen and (max-width: ` +
    breakpoint +
    `) {
        min-width: 225px;
        max-width: 100%;
        margin-left: 1px;
        margin-right: 1px;
        margin-bottom: initial;
      }
      &:hover,
      &:focus,
      &:active {
        border: 1px solid #0696d7;
        box-shadow: none;
      }
    }
    .hig__text-area__field {
      ::-moz-selection { 
        background-color: #0696d7;
      }
      ::selection {
        background-color: #0696d7;
      }
      min-width: inherit;
      max-width: inherit;
      width: inherit;
      border-radius: 0px;
      margin: 0px;
      padding: 10px;
      border: none;
      outline: none;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }

    .hig__text-area__field.hig__text-area__field--no-value::-webkit-input-placeholder {
      color: #999999;
    }
    .hig__text-area__field.hig__text-area__field--no-value::-moz-placeholder {
      color: #999999;
    }
    .hig__text-area__field.hig__text-area__field--no-value:-moz-placeholder {
      color: #999999;
    }
    .hig__text-area__field.hig__text-area__field--no-value:-ms-input-placeholder {
      color: #999999;
    }

    .hig__text-area__field:focus,
    .hig__text-area__field:hover,
    .hig__text-area__field:active {
      border: none;
      box-shadow: none;
    }
  `
  );
}

/**
 * PhoneInput CSS element.
 *
 * @returns { CSS } element
 */
export function phoneInput() {
  return (
    `
    font-family: "ArtifaktElement";
    font-size: 14px;
    font-weight: normal;
    color: #666666;
    min-width: 292px;
    height: 34px;
    margin-bottom: 24px;
    border: 1px solid #DAE1E6;
    &:hover {
      border: 1px solid #0696d7;
    }
    @media only screen and (max-width: ` +
    breakpoint +
    `) {
      min-width: 225px;
      max-width: 100%;
      margin-left: 1px;
      margin-right: 1px;
    }
    .react-tel-input {
      width: 100%;
      height: 100%;
      margin: 0px;
      padding: 0px;
      border-radius: 0px;
      font-family: inherit;
      font-size: inherit;
      font-weight: inherit;
      color: inherit;
    }
    &.invalid-phone {
      border: 1px solid #dd2222;
      &:hover {
        border: 1px solid #dd2222;
      }
      span {
        margin-left: 2px;
      }
    }
    .react-tel-input input[type='tel'] {
      border: none;
      outline: none;
      height: 100%;
      width: 100%;
      font-family: inherit;
      font-size: inherit;
      font-weight: inherit;
      color: inherit;
      margin: 0px;
      padding: 0px;
      text-indent: 10px;
    }
    .react-tel-input input[type=tel].invalid-number, 
    .react-tel-input input[type=tel].invalid-number:focus {
      .react-tel-input:parent {
        border: 1px solid #dd2222;
      }
      border: 0px;
      border-radius: 0px;
      background-color: #ffffff;
      margin-bottom: 0px;
      // &:hover {
      //   border: 1px solid #dd2222;
      // }
    }
    .flag-dropdown {
      display: none;
    }
  `
  );
}

/**
 * errorMessage CSS element.
 *
 * @returns { CSS } element
 */
export function errorMessage() {
  return `
    font-family: "ArtifaktElement";
    font-size: 12px;
    font-weight: normal;
    // line-height: 30px;
    color: #dd2222;
    display: flex;
    align-items: center;
  `;
}

/**
 * errorNotice CSS element.
 *
 * @returns { CSS } element
 */
export function errorNotice() {
  return `
    font-family: "ArtifaktElement";
    font-size: 14px;
    font-weight: normal;
    // line-height: 30px;
    color: #dd2222;
    margin-bottom: 22px;
  `;
}

/**
 * StandardText CSS element.
 *
 * @returns { CSS } element
 */
export function standardText() {
  return `
    font-family: "ArtifaktElement";
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    color: #666666;
    margin-bottom: 24px;
  `;
}

/**
 * LargeText CSS element.
 *
 * @returns { CSS } element
 */
export function largeText() {
  return `
    font-family: "ArtifaktElement";
    font-size: 16px;
    line-height: 21px;
    font-weight: 300;
    font-style: normal;
    color: #666666;
  `;
}

/**
 * counterText CSS element.
 *
 * @returns { CSS } element
 */
export function counterText() {
  return `
    font-family: "ArtifaktElement";
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    color: #666666;
    float: right;
  `;
}

/**
 * flexRow CSS element.
 *
 * @returns { CSS } element
 */
export function flexRow() {
  return (
    `
    display: flex;
    @media only screen and (max-width: ` +
    breakpoint +
    `) {
      flex-flow: column wrap;
      // margin-right: 0px;
    }
  `
  );
}

/**
 * flexColumn CSS element.
 *
 * @returns { CSS } element
 */
export function flexColumn() {
  return (
    `
    margin-right: 24px;
    @media only screen and (max-width: ` +
    breakpoint +
    `) {
      width: 100%;
    }
  `
  );
}

/**
 * horizontalLine CSS element.
 *
 * @returns { CSS } element
 */
export function horizontalLine() {
  return `
    margin: 47.5px 0px 0px;
    // width: 670px;
    height: 0px;
    padding: 0px;
  `;
}

/**
 * spinner CSS element.
 *
 * @returns { CSS } element
 */
export function spinner() {
  return `

  `;
}
